export enum ETablePageQueryParams {
    entity = 'entity',
    entityType = 'entityType',
    modalName = 'modalName',
    modalEntityName = 'modalEntityName',
    dffName = 'dffName',
    dffCode = 'dffCode',
    requestNumber = 'requestNumber',
}
